import React, { useState, useCallback } from "react";

export function EmailSignup() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");

  const handleSubmit = useCallback(async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus("loading");
    try {
      const res = await fetch("/api/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim() }),
      });
      if (res.ok) {
        setStatus("success");
        setEmail("");
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  }, [email]);

  return (
    <section className="w-full">
      <div className="rounded-[16px] border border-dark-gray bg-deep-navy p-8 sm:p-10">
        <h3 className="font-display font-bold text-xl mb-2">Stay in the loop</h3>
        <p className="text-sm text-warm-gray mb-6">
          Get notified when we launch new games, features, and community events. No spam, ever.
        </p>

        {status === "success" ? (
          <p className="text-electric-mint font-display font-semibold text-sm">
            You&apos;re in! We&apos;ll be in touch.
          </p>
        ) : (
          <form onSubmit={handleSubmit} className="flex gap-3 items-center">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
              className="font-body text-sm bg-surface border border-dark-gray text-chalk px-4 py-3 rounded-[12px] outline-none transition-all duration-150 w-full max-w-[300px] focus:border-electric-mint focus:shadow-[0_0_0_3px_rgba(0,240,160,0.1)] placeholder:text-mid-gray"
            />
            <button
              type="submit"
              disabled={status === "loading"}
              className="font-display font-bold text-sm px-6 py-3 rounded-[12px] bg-electric-mint text-midnight hover:bg-[#33FFB8] hover:-translate-y-[1px] transition-all duration-200 whitespace-nowrap disabled:opacity-50"
            >
              {status === "loading" ? "..." : "Subscribe"}
            </button>
          </form>
        )}
        {status === "error" && (
          <p className="text-neon-coral text-xs mt-2">Something went wrong. Try again.</p>
        )}
      </div>
    </section>
  );
}
